"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyLine = void 0;
/**
 * Object representing a line from the content of .properties file.
 */
var PropertyLine = /** @class */ (function () {
    /**
     * Create a new line object.
     *
     * @param line - The raw content of a line.
     * @param isMultiline - Is the line spreading on multiple lines?
     */
    function PropertyLine(line, isMultiline) {
        /** True if the line is continuing to the next line, otherwise false. */
        this.isContinuing = false;
        /** True if the line is blank, otherwise false. */
        this.isBlank = false;
        /** True if the line is a comment, otherwise false. */
        this.isComment = false;
        this.content = line.trimStart();
        this.isMultiline = isMultiline;
        if (this.content.length === 0) {
            // Line is blank.
            this.isBlank = true;
        }
        else {
            if (!this.isMultiline) {
                // Line is a comment.
                this.isComment = !!/^[!#]/.test(this.content);
            }
            if (!this.isComment) {
                // Otherwise, check if the line is continuing on the next line.
                var backslashMatch = this.content.match(/(?<backslashes>\\+)$/);
                if (backslashMatch === null || backslashMatch === void 0 ? void 0 : backslashMatch.groups) {
                    // If the number of backslashes is odd, the line is continuing, otherwise it doesn't.
                    this.isContinuing = !!(backslashMatch.groups.backslashes.length % 2);
                    if (this.isContinuing) {
                        // Remove the trailing slash so that we can concatenate the line with the next one.
                        this.content = this.content.slice(0, -1);
                    }
                }
            }
        }
    }
    return PropertyLine;
}());
exports.PropertyLine = PropertyLine;
